import React, { useEffect } from 'react';
import './product.scss';
import DynamicInputList from '../software-dynamic-version-7/list-input-v-7';
import moment from 'moment';
import securityService from '../security/security.service';
import productService from './product.service';
import ProductAdd from './product-add';
import hardDeleteService from '../../services/hard-delete.service';



const ProductList = (props) => {
  
  const columns = [
    { field: "ProductID", headerText: "ID", width: "80px", textAlign: "right", headerTextAlign: "center", other: [{}]  },
    { field: "OpeningDate", headerText: "Opening Date", width: "120px", textAlign: "left", headerTextAlign: "center" , other: [{}] },
    { field: "ProductName", headerText: "Product Name", width: "200px", textAlign: "left", headerTextAlign: "center" , other: [{}] },
    { field: "hS_CODE", headerText: "HS Code", width: "130px", textAlign: "left", headerTextAlign: "center" , other: [{}] },
    { field: "uoM", headerText: "UOM", width: "100px", textAlign: "center", headerTextAlign: "center" , other: [{}] },
    { field: "OpeningQuantity", headerText: "Quantity", width: "130px", textAlign: "right", headerTextAlign: "center", other: [{ format: "n2" }] },
    { field: "OpeningRate", headerText: "Rate", width: "130px", textAlign: "right", headerTextAlign: "center", other: [{ format: "n2" }] },
    { field: "TaxPercent", headerText: "Tax %", width: "100px", textAlign: "right", headerTextAlign: "center", other: [{ format: "n2" }] }
  ];

  const getList = async () => {
    const data = {};
    return await productService.getForList(data);
  };

  const listActionComplete = async (grid, args, getListService, selectedRow) => {
    if (args.requestType === 'save' || args.requestType === 'cancel') {
      getListService();
    }

    if (args.requestType === 'save') {
      console.log(args)
      if (args.action === 'add') {
        const data = {
          ProductDescription1ID: args.data.ProductDescription1ID,
          ProductDescription2ID: args.data.ProductDescription2ID,
          ProductDescription3ID: args.data.ProductDescription3ID,
          ProductDescription4ID: args.data.ProductDescription4ID,
          ProductDescription5ID: args.data.ProductDescription5ID,
          ProductDescription6ID: args.data.ProductDescription6ID,
          ProductName: args.data.ProductName || '',
          GDID: args.data.GDID,
          hS_CODE: args.data.hsCodeID || '',
          uoM: args.data.uoM || '',
          OpeningQuantity: args.data.OpeningQuantity || 0,
          OpeningRate: args.data.OpeningRate || 0,
          TaxPercent: args.data.TaxPercent || 0,
          OpeningDate: moment(args.data.OpeningDate).format('DD-MMM-YY'),
          UnitOfMeasurementID: args.data.UnitOfMeasurementID,
        };

        const response = await productService.addRecords(data);
        if (response) await getListService();
      }

      if (args.action === 'edit' && args.data.ProductID) {
        const data = {
          ProductID:args.data.ProductID,
          ProductDescription1ID: args.data.ProductDescription1ID,
          ProductDescription2ID: args.data.ProductDescription2ID,
          ProductDescription3ID: args.data.ProductDescription3ID,
          ProductDescription4ID: args.data.ProductDescription4ID,
          ProductDescription5ID: args.data.ProductDescription5ID,
          ProductDescription6ID: args.data.ProductDescription6ID,
          ProductName: args.data.ProductName || '',
          GDID: args.data.GDID,
          hS_CODE: args.data.hsCodeID || '',
          uoM: args.data.uoM || '',
          OpeningQuantity: args.data.OpeningQuantity || 0,
          OpeningRate: args.data.OpeningRate || 0,
          TaxPercent: args.data.TaxPercent || 0,
          OpeningDate: moment(args.data.OpeningDate).format('DD-MMM-YY'),
          UnitOfMeasurementID: args.data.UnitOfMeasurementID,
        };

        await productService.updateMainData(data);
        await getListService();
      }
    }
  };

  const toolbarClicking = async (grid, args) => {
    // const itemId = args?.item?.id;
    // if (itemId !== "delete") return;

    // const selected = grid?.getSelectedRecords ? grid.getSelectedRecords()[0] : null;
    // if (!selected?.ProductID) {
    //   alert("Please select a product row first.");
    //   return;
    // }

    // if (window.confirm('Are you sure you want to delete this product?')) {
    //   try {
    //     const data = {
    //       TableName: 'Product',
    //       ColumnName: 'ProductID',
    //       RowID: selected.ProductID
    //     };
    //     await hardDeleteService.hardDelete(data);
    //     alert('Product deleted successfully');
    //     const getListService = () => grid.refresh();
    //     await getListService();
    //   } catch (error) {
    //     console.error('Delete failed:', error);
    //     alert('Failed to delete product');
    //   }
    // }
  };

  const ListSecurity = true;
  const AddSecurity = true;
  const EditSecurity = true;
  const DeleteSecurity = true;

  const toolbarOptions = ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Search', 'ColumnChooser'];

  const allowTemplate = false;
  const allowGridSum = true;
  const gridSumColumns = ['OpeningQuantity'];

  const listDelete = [{ TableName: ['Product'], TableID: ['ProductID'] }];
  const deleteType = 'Hard';

 

  return (
    <DynamicInputList
      Id='Product'
      ListTitle={`${props?.Title || 'PRODUCT'} - List`}
      ColumnsList={columns}
      GridDataSource={[
        {
          DataSourceType: 'Function',
          DataSource: () => getList()
        }
      ]}
      DefaultSortedColumnName={'ProductID'}
      GridDialog={[
        {
          DialogType: 'Self',
          Dialog: (
            <ProductAdd
              
              UserID={securityService.getLoggedInUserId()}
              Title={`${props?.Title || 'PRODUCT'}`}
              {...props}
            />
          )
        }
      ]}
      ListActionComplete={listActionComplete}
      ToolbarClicking={toolbarClicking}
      AllowTemplate={allowTemplate}
      ToolbarOption={toolbarOptions}
      ListSecurity={ListSecurity}
      AddSecurity={AddSecurity}
      EditSecurity={EditSecurity}
      DeleteSecurity={DeleteSecurity}
      // ListDelete={listDelete}
      DeleteType={deleteType}
      GridSumColumns={gridSumColumns}
      AllowGridSum={allowGridSum}
      HeadTitle={`${props?.Title || 'PRODUCT'} - List`}
      IsDialog={props?.IsDialog ?? props?.isDialog ?? false}
      {...props}
    />
  );
};

export default ProductList;